import "bootstrap/dist/css/bootstrap.min.css";
import _ from "lodash";
import React, { Component } from "react";
//import { Link } from 'react-router-dom';
import { Link, NavLink } from "react-router-dom";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
//import TabNavs from '../../components/TabNavs.jsx';
import eyeIcon from "../../assets/Icons/eye.svg";
import copy2clipboardIcon from "../../assets/Icons/copy2clipboard.svg";
import csvIcon from "../../assets/Icons/csv.svg";
import editIcon from "../../assets/Icons/edit.svg";
import exportIcon from "../../assets/Icons/export.svg";
import importIcon from "../../assets/Icons/import.svg";

//icons
import newIcon from "../../assets/Icons/new.svg";
import pdfIcon from "../../assets/Icons/pdf.svg";
import printIcon from "../../assets/Icons/printer-xxl.svg";
import trashIcon from "../../assets/Icons/trash.svg";
import xlsIcon from "../../assets/Icons/xls.svg";
//import FloatSubMenu from './../../components/float-sub-menu/float-sub-menu';
import Pagination from "../../common/pagination";
import COOItemsTable from "../../components/COOItemsTable.jsx";
import { getCOOItems, deleteCOOItem, batchAddCOOItems } from "../../services/cooitems";
import { paginate } from "../../utils/paginate";
import SearchBox from "./../../common/searchBox";
import {
  Panel,
  PanelBody,
  PanelHeader,
} from "./../../components/panel/panel.jsx";
// import { apiUrl } from "./../../config/config.json";
import http from "./../../services/httpService";
import Spreadsheet from "../../components/Spreadsheet/SpreadSheet.jsx";
import auth from "../../services/authservice";

const apiUrl = process.env.REACT_APP_API_URL;

class COOItemTableData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      COOitems: [],
      pageSize: 10,
      currentPage: 1,
      sortColumn: { path: "title", order: "asc" },
      searchQuery: "",
      errors: {},
      checkedFields: [],
      tabs: [
        { label: 'Web Grid', style: { background: '#0c1dc9' } },
        { label: 'XLS', style: { background: '#08a112' } },
      ],

    };

    this.handleDelete = this.handleDelete.bind(this);
  }

  async componentDidMount() {
    document.title = "COOItems";    
    const { data } = await getCOOItems();
    console.log(data);
    this.setState({ COOitems: data });
  }

  //check box change
  handleCheckboxChange = ({ target: { checked, value } }) => {
    if (checked) {
      const checkedFields = [...this.state.checkedFields, value];
      this.setState({ checkedFields });
    } else {
      const checkedFields = [...this.state.checkedFields];
      this.setState({
        checkedFields: checkedFields.filter((e) => e !== value),
      });
    }
  };

  handleSelectAll = (event) => {
    // whole state was passed and this was 
    //const { COOitems } = this.state;
    const { data: COOitems } = this.getDataPgnation();
    if (event.target.checked) {
      // If the checkbox is checked, select all items
      this.setState({ checkedFields: COOitems.map(item => item._id) });
    } else {
      // If the checkbox is unchecked, clear the selection
      this.setState({ checkedFields: [] });
    }
  };

  handleMassDelete = async (CheckedFields) => {
    const originalCOOItems = this.state.COOitems;

    // First, filter out the items to delete from the current state
    const itemsToDelete = this.state.COOitems.filter(item =>
      CheckedFields.includes(item._id)
    );

    // Delete all checked items asynchronously
    try {
      await Promise.all(itemsToDelete.map(COOitem => deleteCOOItem(COOitem._id)));

      const COOitems = this.state.COOitems.filter(item =>
        !CheckedFields.includes(item._id)
      );

      this.setState({ COOitems });
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        alert("Some items have already been deleted");
      }

      this.setState({ COOitems: originalCOOItems });
    }
  };


  // handleMassDelete = (CheckedFields) => {
  //   const originalCOOItems = this.state.COOitems;
  //   CheckedFields.map(async (COOitem) => {
  //     const COOitems = this.state.COOitems.filter((COOItem) => COOItem._id !== COOitem);

  //     try {
  //       await deleteCOOItem(COOitem);
  //       this.setState({ COOitems });
  //     } catch (ex) {
  //       if (ex.response && ex.response === 404) {
  //         alert("already deleted");
  //       }

  //       this.setState({ COOitems: originalCOOItems });
  //     }
  //   });
  // };

  handleDelete = async (COOitem) => {
    ///delete
    const originalCOOItems = this.state.COOitems;
    const COOitems = this.state.COOitems.filter((COOItem) => COOItem._id !== COOitem._id);
    this.setState({ COOitems });
    try {
      await deleteCOOItem(COOitem._id);
    } catch (ex) {
      //ex.request
      //ex.response

      if (ex.response && ex.response === 404) {
        alert("already deleted");
      }

      this.setState({ COOitems: originalCOOItems });
    }
    ////
  };

  //sorting columns
  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };
  handlePageChange = (page) => {
    console.log(page);
    this.setState({ currentPage: page });
  };

  handleSearch = (query) => {
    console.log(query);
    this.setState({ searchQuery: query, currentPage: 1 });
  };

  getDataPgnation = () => {
    const {
      pageSize,
      currentPage,
      COOitems: COOItems,
      sortColumn,
      searchQuery,
    } = this.state;

    let filtered = COOItems;
    if (searchQuery) {
      console.log(searchQuery);
      filtered = COOItems.filter(
        (el) => {
          return el?.repairVendor?.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
            el?.serial?.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
            el?.SKU?.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
            el?.user?.username?.toLowerCase().startsWith(searchQuery.toLowerCase()) ||
            el?.COOitemname?.toLowerCase().startsWith(searchQuery.toLowerCase())
        }
      );
    }

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
    const COOitems = paginate(sorted, currentPage, pageSize);

    return { data: COOitems, totalCount: filtered.length };
  };

  handleFileUpload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls,.xlsm,.csv';

    input.onchange = (event) => {
      const file = event.target.files[0];
      if (file) {
        this.processFile(file);
      }
    };

    input.click();
  };

  processFile = (file) => {
    const validExtensions = [".csv", ".xlsx", ".xls", ".xlsm"];
    const fileExtension = file.name
      .toLowerCase()
      .substr(file.name.lastIndexOf("."));

    if (!validExtensions.includes(fileExtension)) {
      toast.error(
        "Please select a valid Excel (.xlsx, .xls, .xlsm) or CSV (.csv) file"
      );
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        let workbook;
        let jsonData;

        if (file.name.endsWith(".csv")) {
          const csvData = e.target.result;
          workbook = XLSX.read(csvData, { type: "string" });
        } else {
          const data = new Uint8Array(e.target.result);
          workbook = XLSX.read(data, { type: "array" });
        }

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });


        this.handleBatchUpload(jsonData);
      } catch (error) {
        console.error("Error processing file:", error);
        toast.error(
          "Error processing file. Please check the file format and try again."
        );
      }
    };

    if (file.name.endsWith(".csv")) {
      reader.readAsText(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  };
  handleBatchUpload = async (jsonData) => {
    try {
      const currentUser = auth.getProfile();

      if (jsonData.length < 2) {
        toast.error("File must contain at least a header row and one data row");
        return;
      }

      // Normalize headers
      const headers = jsonData[0].map((h) => String(h).toLowerCase().trim());
      const dataRows = jsonData.slice(1);

      // Expected column mapping with aliases
      const columnAliases = {
        serial: ["serial", "serial number", "serialnumber"],
        repairVendor: ["repairvendor", "vendor", "repair vendor"],
        batch: ["batch", "mdt"],
        SKU: ["sku", "itemcode", "item code"],
        COOonBox: ["cooonbox", "coo_on_box", "coo on the box", "coo on box"],
        COOfromDB: ["coofromdb", "coo_from_db", "coo from db"],
        COOfromPackingList: ["coofrompackinglist", "coo_from_packing_list", "coo on the packing list", "coo from packing list"],
        madeIn: ["madein", "made_in", "coo on the item", "made in"],
        note: ["note"],
        review: ["review", "coo on the hu label"],
        status: ["status"],
        participants: ["participants"],
      };

      // Build column map
      const columnMap = Object.fromEntries(
        Object.entries(columnAliases).map(([key, aliases]) => [
          key,
          headers.findIndex((h) => aliases.includes(h)),
        ])
      );

      // Validate required columns are found
      const missingColumns = [];
      if (columnMap.serial === -1) missingColumns.push('serial/serial number');
      if (columnMap.repairVendor === -1) missingColumns.push('repairVendor/vendor');

      if (missingColumns.length > 0) {
        toast.error(`Missing required columns: ${missingColumns.join(', ')}`);
        console.log('Available headers:', headers);
        console.log('Column mapping:', columnMap);
        return;
      }

      // Log successful mapping for debugging
      const foundColumns = Object.entries(columnMap)
        .filter(([key, index]) => index !== -1)
        .map(([key, index]) => `${key}: "${headers[index]}"`)
        .join(', ');
      console.log('Successfully mapped columns:', foundColumns);

      // Helper to safely get cell value
      const getCellValue = (row, colIndex, fallback = "") =>
        colIndex !== -1 && row[colIndex]
          ? String(row[colIndex]).trim()
          : fallback;

      // Parse participants
      const parseParticipants = (value) => {
        if (!value) return [];
        return String(value)
          .split(",")
          .map((p) => p.trim())
          .filter(Boolean)
          .map((p) => (/^[0-9a-fA-F]{24}$/.test(p) ? p : p)); // email or ObjectId
      };

      // Transform rows
      const cooItems = dataRows
        .map((row, idx) => {
          const item = {
            user: currentUser._id,
            serial: getCellValue(row, columnMap.serial),
            repairVendor: getCellValue(row, columnMap.repairVendor),
            batch: getCellValue(row, columnMap.batch),
            SKU: getCellValue(row, columnMap.SKU),
            COOonBox: getCellValue(row, columnMap.COOonBox),
            COOfromDB: getCellValue(row, columnMap.COOfromDB),
            COOfromPackingList: getCellValue(row, columnMap.COOfromPackingList),
            madeIn: getCellValue(row, columnMap.madeIn),
            note: getCellValue(row, columnMap.note),
            review: getCellValue(row, columnMap.review),
            status: getCellValue(row, columnMap.status, "new"),
            participants: parseParticipants(
              getCellValue(row, columnMap.participants)
            ),
          };

          if (!item.serial) {
            console.warn(`Row ${idx + 2}: Serial is required`);
            return null;
          }
          if (!item.repairVendor) {
            console.warn(`Row ${idx + 2}: Repair Vendor is required`);
            return null;
          }

          return item;
        })
        .filter(Boolean);

      if (cooItems.length === 0) {
        toast.warning(
          'No valid data found. Ensure "serial" and "repairVendor" are filled.'
        );
        return;
      }

      const loadingToast = toast.loading("Importing COO Items...");
      const response = await batchAddCOOItems({ items: cooItems });
      toast.dismiss(loadingToast);

      if ([200, 201].includes(response.status)) {
        toast.success(`Successfully imported ${cooItems.length} COO Items from ${dataRows.length} rows`);
        const { data } = await getCOOItems();
        this.setState({ COOitems: data });
      } else {
        toast.error("Failed to import items");
      }
    } catch (error) {
      console.error("Batch upload error:", error);
      toast.error(
        "Error importing items. Please check your file format and try again."
      );
    }
  };

  render() {
    const { length: originalCount } = this.state.COOitems;
    const { pageSize, currentPage, sortColumn, searchQuery } = this.state;

    const { data: COOitems, totalCount } = this.getDataPgnation();

    const displayCount = searchQuery ? totalCount : originalCount;

    console.log(this.state.checkedFields);

    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="ERP/COOitems">COO Items</Link>
          </li>
        </ol>

        <h1 className="page-header">COOItems </h1>
        <Panel>
          <PanelHeader>COOItems Management</PanelHeader>

          <React.Fragment>
            <ToastContainer />

            <div className="toolbar" style={toolbarStyles}>

              <button
                className="btn btn-default active m-r-5 m-b-5"
                title="add COOitem"
                style={btnStyles}
              >
                {" "}
                <Link to="/ERP/COOItems/new/">
                  <img style={iconStyles} src={newIcon} />
                </Link>{" "}
              </button>
              <NavLink
                className="btn btn-default active m-r-5 m-b-5"
                title="edit COOitem"
                style={btnStyles}
                to={
                  this.state.checkedFields
                    ? `/ERP/COOItems/${this.state.checkedFields[0]}`
                    : "/ERP/COOItems/"
                }
              >
                {/* {" "}
        <Link
          to={
            this.state.checkedFields
              ? `/clinic/users/${this.state.checkedFields[0]}`
              : "/clinic/users/"
          }
        > */}
                <img style={iconStyles} src={editIcon} />
                {/* </Link>{" "} */}
              </NavLink>
              <button
                className="btn btn-default active m-r-5 m-b-5"
                title="delete COOitem"
                style={btnStyles}
                onClick={() => this.handleMassDelete(this.state.checkedFields)}
              >
                {" "}
                {/* <Link to="/clinic/users/del"> */}
                <img
                  style={{ width: "25px", height: "25px" }}
                  src={trashIcon}
                />
                {/* </Link>{" "} */}
              </button>
              <button
                className="btn btn-default active m-r-5 m-b-5"
                title="csv"
                style={btnStyles}
                value="csv"
                onClick={this.exportExcel}
              >
                <img style={iconStyles} src={csvIcon} />
              </button>

              <button
                className="btn btn-default active m-r-5 m-b-5"
                title="pdf"
                style={btnStyles}
                onClick={this.exportPdf}
              >
                <img style={iconStyles} src={pdfIcon} />
              </button>

              <button
                className="btn btn-default active m-r-5 m-b-5"
                title="Upload Excel/CSV File"
                style={btnStyles}
                onClick={this.handleFileUpload}
              >
                <img style={iconStyles} src={xlsIcon} />
              </button>

              <ReactToPrint content={() => this.tableRef}>
                <PrintContextConsumer>
                  {({ handlePrint }) => (
                    <button
                      className="btn btn-default active m-r-5 m-b-5"
                      title="print"
                      style={btnStyles}
                      onClick={handlePrint}
                    >
                      <img style={iconStyles} src={printIcon} />
                    </button>
                  )}
                </PrintContextConsumer>
              </ReactToPrint>

              <Dropdown
                as="button"
                className="btn btn-default active m-r-5 m-b-5"
                isOpen={this.state.exportDropdownOpen}
                toggle={this.toggleExport}
                style={btnStyles}
              >
                <DropdownToggle
                  caret
                  title="export"
                  style={{
                    padding: 0,
                    margin: 0,
                    border: 0,
                    background: "inherit",
                  }}
                >
                  <img style={iconStyles} src={exportIcon} />
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem value="xlsx" onClick={this.exportExcel}>
                    <img style={iconStyles} src={xlsIcon} /> Excel
                  </DropdownItem>
                  <DropdownItem value="csv" onClick={this.exportExcel}>
                    <img style={iconStyles} src={csvIcon} /> CSV
                  </DropdownItem>
                  <DropdownItem onClick={this.exportPdf}>
                    <img style={iconStyles} src={pdfIcon} />
                    PDF
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>

            </div>

            <div className="table-responsive">
              <SearchBox value={searchQuery} onChange={this.handleSearch} />
              <p
                className="page-header float-xl-left"
                style={
                  ({ marginBottom: 5 }, { marginLeft: 20 }, { marginTop: 5 })
                }
              >
                {displayCount} entries
              </p>

              <COOItemsTable
                COOitems={COOitems}
                onDelete={this.handleDelete}
                onSort={this.handleSort}
                sortColumn={sortColumn}
                handleCheckboxChange={this.handleCheckboxChange}
                handleSelectAll={this.handleSelectAll}
                checkedFields={this.state.checkedFields}
              />
            </div>
          </React.Fragment>

          <hr className="m-0" />
          <PanelBody>
            <div className="d-flex align-items-center justify-content-center">
              <Pagination
                itemsCount={totalCount}
                pageSize={pageSize}
                onPageChange={this.handlePageChange}
                currentPage={currentPage}
              />
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}

const toolbarStyles = {
  background: "#c8e9f3",
  padding: "10px",
};

const btnStyles = { background: "#348fe2", margin: "0rem" };

const iconStyles = {
  width: "25px",
  height: "25px",
  marginRight: "0rem",
};

const CustomDropdownItem = ({ path, order, handleSort, icon, COOitem }) => {
  return (
    <DropdownItem
      onClick={() =>
        handleSort({
          path,
          order,
        })
      }
    >
      {/* <img src={icon} alt={COOitem} style={{ height: "20px" }} /> */}
      <COOitem>
        <input
          type="checkbox"
          style={{
            width: "15px",
            height: "15px",
            marginTop: "0.4rem",
            borderRadius: 0,
          }}
        />{" "}
        {COOitem}
      </COOitem>
    </DropdownItem>
  );
};

export default COOItemTableData;



